export const getElementoInside = (arrCasillas, respuesta) => {
    let arrChecked = arrCasillas.map(element => ({
        id: element.id, checked: element.qualifications.filter(e=>e.checked).map(e=>({id: e.id}))
    }))
    return arrChecked    
} 